<!-- <i (click)="toggleFavourite()" class="theme-bingo-heart" [ngClass]="isFavourite?favAddClass:favRemClass"></i> -->
<i class="favoriteIcon" [ngClass]="[isFavourite ? favMarkedIcon : favIcon, isFavourite ? 'added' : '']" (click)="toggleFavourite()"></i>
